import * as jsxRuntime from "E:\\Pro Npm Run Dev\\NpmNono\\npm06-front\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment